<template>
  <v-dialog width="300px" v-model="showModal" persistent>
    <v-card>
      <v-card-title class="headline text-center">
        <strong>{{ command }} saldo</strong>
      </v-card-title>

      <v-card-text>
        <v-select
          v-if="command == 'Retirar'"
          v-model="data.type"
          :items="typeRetirada"
          label="Tipo de retirada"
        ></v-select>

        <label>Valor</label>
        <money v-model="data.value" v-bind="money" class="form-control"></money>
      </v-card-text>

      <v-card-text v-if="data.type == 'Cobrança'">
        <label>ID Reserva</label>
        <input
          type="number"
          v-model="data.idReserva"
          class="form-control"
          required
        />
      </v-card-text>

      <v-card-actions class="text-center align-center">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" @click="$emit('btnNao')">
          Cancelar
        </v-btn>
        <v-btn color="green darken-1" @click="$emit('btnSim', data)">
          {{ command }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    formFields: Array,
    command: String,
  },
  data() {
    return {
      typeRetirada: ['Saque', 'Cobrança'],
      data: {
        type: null,
        value: null,
        idReserva: null,
      },
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
    };
  },
};
</script>
